import { DataGrid, mergeSx, type DataGridProps } from '@shared/components';

import { computerColumns, paperBasedColumns, type ExamineeColumn } from './columns';
import ExamineesDataGridNoRowsOverlay from './examinees-data-grid-no-rows-overlay';

export interface ExamineesDataGridProps extends Omit<DataGridProps<ExamineeColumn>, 'columns'> {
  variant: 'paper' | 'computer';
}

export default function ExamineesDataGrid(props: Readonly<ExamineesDataGridProps>) {
  const { rows, sx, variant = 'computer', ...restProps } = props;

  return (
    <DataGrid
      {...restProps}
      disableColumnMenu
      rows={rows}
      columns={variant === 'computer' ? computerColumns : paperBasedColumns}
      hideFooter={rows.length === 0}
      rowHeight={48}
      sx={mergeSx(
        (theme) => ({
          '--DataGrid-overlayHeight': '124px',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            p: theme.spacing(3),
          },
          '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          // Style override for Footer
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sx,
      )}
      slots={{
        noRowsOverlay: ExamineesDataGridNoRowsOverlay,
      }}
    />
  );
}
